import "core-js/modules/es6.number.constructor";
export default function toNumberOrUndefined(val) {
  if (typeof val === 'undefined') return val;
  return Number(val);
}